import { render, staticRenderFns } from "./ElementActionsTableColumn.vue?vue&type=template&id=f0af5046"
import script from "./ElementActionsTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementActionsTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports